import { i18next } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

const CALLER_LABEL_MAX_LENGTH = 26;

const CALLER_LABEL_BASE_TEXT = i18next.t('Label displays on Weave phone screen and Call Pop while call is ringing', {
  ns: 'phone',
});

const isOverMaxLength = (value?: string, maxLength = CALLER_LABEL_MAX_LENGTH): boolean =>
  (value?.length ?? 0) > maxLength;

export const CallerLabelBaseText: React.FC<{ value?: string; error?: string }> = ({ value, error }) => {
  const baseText = CALLER_LABEL_BASE_TEXT;

  if (!value || error || isOverMaxLength(value)) return null;

  return (
    <Text size='small' color='subdued' css={{ marginTop: theme.spacing(-3) }}>
      {baseText}
    </Text>
  );
};

export const getRemainingCharacters = (value?: string, maxLength = CALLER_LABEL_MAX_LENGTH): string => {
  if (!value) {
    return CALLER_LABEL_BASE_TEXT;
  }

  const remaining = maxLength - value.length;

  if (isOverMaxLength(value, maxLength)) {
    return i18next.t('{{count}}/26 characters. Shorten label to 26 characters.', { count: value.length, ns: 'phone' });
  }

  return i18next.t('{{remaining}}/{{maxLength}} characters remaining.', { remaining, maxLength, ns: 'phone' });
};
